export enum enumDiscountScopeType {
    None = 0,
    User = 1,
    Dealer = 2,
    Customer = 3,
    Cart = 4,
    Time = 5
};